/* istanbul ignore file */
import {
  Icon,
  LabeledBevestigingInput,
  LabeledDateInput,
  LabeledText,
  ModalButton,
  bedragFormat
} from "adviesbox-shared";
import { connect, FormikContextType } from "formik";
import React, { ReactElement } from "react";
import { AdresInput } from "../../shared/components/adres/adres-input";
import LabeledHdnKeuzelijst from "../../shared/components/hdn-keuzelijst/LabeledHdnKeuzelijst";
import OnderpandModalContent from "../../shared/components/onderpand/OnderpandModal";
import { AdresType } from "../../shared/types";
import { getWoningTextResources } from "../infra/woning-resources";
import { WoningState } from "../infra/woning-schema";
import FotoWoning from "../components/foto-woning";

export const createDuurzaamLink = (adres: AdresType): string => {
  if (adres.huisnummer && adres.postcode) {
    return `https://www.duurzaamheidsprofiel.nl/?postal_code=${adres.postcode}&house_number=${adres.huisnummer}`;
  }
  if (adres.huisnummer && !adres.postcode) {
    return `https://www.duurzaamheidsprofiel.nl/?house_number=${adres.huisnummer}`;
  }
  if (!adres.huisnummer && adres.postcode) {
    return `https://www.duurzaamheidsprofiel.nl/?postal_code=${adres.postcode}`;
  }
  return `https://www.duurzaamheidsprofiel.nl`;
};

type AanTeKopenWoningProps = {
  addressChangeKey: number;
  handleAddressChanged: () => void;
};
const AanTeKopenWoning = ({
  formik,
  addressChangeKey,
  handleAddressChanged
}: AanTeKopenWoningProps & {
  formik: FormikContextType<WoningState>;
}): ReactElement => {
  const { adresGelijkAanWoonadres, adres } = formik.values.aanTeKopenWoning;
  const onderpandTekst = formik.values.aanTeKopenWoning.onderpand.bouwjaar
    ? `Bouwjaar:  ${formik.values.aanTeKopenWoning.onderpand.bouwjaar}` +
      (formik.values.aanTeKopenWoning.onderpand.serviceKosten &&
      formik.values.aanTeKopenWoning.onderpand.serviceKosten > 0
        ? `, Servicekosten:  ${bedragFormat(formik.values.aanTeKopenWoning.onderpand.serviceKosten, 2)}`
        : "")
    : "Geen gegevens ingevuld";

  const aanTeKopenWoning = formik.values.aanTeKopenWoning;

  return (
    <div>
      <LabeledHdnKeuzelijst
        caption="Object soort"
        name="aanTeKopenWoning.onderpand.objectSoort"
        keuzelijst="ObjectSoortType"
        berichtSoortType="AX"
        fieldSize="xl"
        appendLabelChildren={
          <span style={{ marginLeft: "5px" }}>
            <sub>
              <a
                href={"https://support.adviesbox.nl/portal/nl/kb/articles/object-soort"}
                className="link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Toelichting
              </a>
            </sub>
          </span>
        }
      />

      <LabeledText
        id="onderpand-label"
        caption="Onderpand"
        value={onderpandTekst}
        appendChildren={
          <ModalButton
            resetSize={true}
            parent="aanTeKopenWoning.onderpand"
            aria-label={getWoningTextResources("OnderPandSpecificatieKnop")}
            content={<Icon name="specificatie" alt="Onderpand specificatie" />}
          >
            <OnderpandModalContent
              data={aanTeKopenWoning.onderpand}
              onSave={(result): void => {
                const values: WoningState = {
                  ...formik.values,
                  aanTeKopenWoning: {
                    ...aanTeKopenWoning,
                    onderpand: { ...result, gebruikPand: formik.values.aanTeKopenWoning.onderpand.gebruikPand }
                  }
                };
                formik.setValues(values);
              }}
            />
          </ModalButton>
        }
      />

      <LabeledHdnKeuzelijst
        caption="Huidig energielabel"
        name="aanTeKopenWoning.energieLabel"
        keuzelijst="EnergieKlasseType"
        berichtSoortType="AX"
        tooltip={getWoningTextResources("TooltipEnergieLabel")}
        fieldSize="xl"
      />

      <div className="form-group form-row  mt-2">
        <div className="col-md-6 col-12">
          <a
            href={createDuurzaamLink(adres)}
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            id={`duurzaamheidsprofiel-link`}
          >
            <span className="ml-3">Duurzaamheidsprofiel</span> <i className="icon externallink" />
          </a>
        </div>
      </div>

      <LabeledDateInput caption="Datum energieklasse" name="aanTeKopenWoning.energieklasseDatum" />

      <LabeledBevestigingInput caption="Adres gelijk aan woonadres" name="aanTeKopenWoning.adresGelijkAanWoonadres" />

      <AdresInput
        readonly={adresGelijkAanWoonadres}
        name={"aanTeKopenWoning.adres"}
        onAddressChanged={handleAddressChanged}
      />

      <FotoWoning
        fotoWoning={aanTeKopenWoning.fotoWoning}
        adres={aanTeKopenWoning.adres}
        modelPrefix="aanTeKopenWoning"
        formik={formik}
        addressChangeKey={addressChangeKey}
        handleAddressChanged={handleAddressChanged}
      />
    </div>
  );
};

export default connect<AanTeKopenWoningProps, WoningState>(AanTeKopenWoning);
